import CouponApi from '@apis/coupon/CouponApi';
import couponQueries from '@apis/queries/couponQueries';
import { GetCouponsParams } from '@models/coupon';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useAtomValue } from 'jotai';

import { couponSortsAtom } from '../../../atoms/couponAtoms';

function useCouponHistories() {
    const sort = useAtomValue(couponSortsAtom).HISTORY;
    const params: Omit<GetCouponsParams, 'page'> = {
        size: 10,
        sorter: sort === 'closingSoon' ? 'ExpiresAtAsc' : 'IssuedAtDesc',
    };
    const queryInfo = useInfiniteQuery({
        queryKey: couponQueries.history(params).queryKey,
        queryFn: ({ pageParam }) => CouponApi.getCouponHistories({
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const coupons = getFlattenPageResponse(queryInfo);
    const isEmpty = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        coupons,
        isEmpty,
    };
}

export default useCouponHistories;
